import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertController, ToastController } from '@ionic/angular';
import { DataService } from '../../data.service';

// Admin → E-napló → KRÉTA naplózás. Tanáronként (saját KRÉTA-belépésével) beírja a Sulinformban
// megtartott+témás órákat és a rögzített jegyeket a KRÉTA e-naplóba. Itt állítod be, melyik
// pedagógus melyik KRÉTA felhasználóval lép be, és innen indítható a szinkron (előbb Teszt, majd éles).
@Component({
  selector: 'app-kreta-naploz',
  templateUrl: './kreta-naploz.component.html',
  styleUrls: ['./kreta-naploz.component.scss'],
})
export class KretaNaplozComponent implements OnInit, OnDestroy {
  private readonly base = '/api/naplo-kreta-naploz';
  sajatIntezmeny: any;
  allomany: any[] = [];            // pedagógusok (a tanár-választóhoz)
  /*  A választó KERESHETŐ: több száz fős állománynál a görgetés használhatatlan.
   *  A rendezés a kiszolgálótól jön (névsor), itt csak szűrünk – így nem tud
   *  elcsúszni attól, amit a többi képernyő mutat.
   */
  allomanySzuro = '';
  hozzaferesek: any[] = [];        // beállított KRÉTA-belépések
  log: any[] = [];
  betolt = false;
  fut = false;
  dryRun = true;                   // alapból TESZT (Validate, nem ír)
  csakTemas = true;                // csak a megtartott+témás órát naplózza
  jegyek = true;                   // a rendszerben rögzített jegyeket is beírja
  jegyAllapot: any = null;         // mi vár átvitelre, és miért nem ment át, ami nem ment
  eredmeny: any = null;
  statusz: any = { fut: false };   // aktuális szinkron-állapot (manuális VAGY automata) – a progressbarhoz
  private statuszTimer: any = null;
  form: any = { allomany: '', tanar_nev: '', kreta_user: '', kreta_pass: '', kreta_totp: '', aktiv: 1 };
  utemezo: any = { enabled: 0, intervallum_perc: 1440, csak_temas: 1, jegyek: 1, kreta_host: null,
                   alapertelmezett_host: '', hasznalt_host: '', utolso_futas: null, utolso_eredmeny: null };

  constructor(private http: HttpClient, private data: DataService, private toast: ToastController, private alert: AlertController) {}

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    if (this.sajatIntezmeny?.intezmenyId) { await this.betoltMind(); this.statuszPollStart(); }
  }
  ngOnDestroy() { if (this.statuszTimer) { clearInterval(this.statuszTimer); this.statuszTimer = null; } }
  get intezmeny() { return this.sajatIntezmeny?.intezmenyId || ''; }

  // Bármely szinkron fut-e (manuális VAGY automata/cron) – ez tiltja a manuális indítást és mutatja a barot.
  get szinkronFut(): boolean { return !!this.statusz?.fut || this.fut; }
  get szazalek(): number { return this.statusz?.osszes ? Math.round((this.statusz.kesz / this.statusz.osszes) * 100) : 0; }

  // A szinkron-állapotot 2,5 mp-enként lekérdezzük, hogy az automata (cron) futást is lássuk élőben.
  private statuszPollStart() {
    this.statuszLeker();
    this.statuszTimer = setInterval(() => this.statuszLeker(), 2500);
  }
  private async statuszLeker() {
    try {
      const s: any = await this.http.get(`${this.base}/naploz-statusz/${this.intezmeny}`).toPromise();
      const voltFut = this.statusz?.fut;
      this.statusz = s || { fut: false };
      // amikor egy futás épp befejeződött: a háttérben indított menet eredménye és a napló
      if (voltFut && !this.statusz.fut) {
        if (this.hatterFutasVar) {
          this.hatterFutasVar = false;
          try { this.eredmeny = await this.http.get(`${this.base}/naploz-eredmeny/${this.intezmeny}`).toPromise(); } catch { /* csendes */ }
        }
        this.betoltMind();
      }
    } catch { /* csendes */ }
  }

  async betoltMind() {
    this.betolt = true;
    try {
      this.hozzaferesek = (await this.http.get<any[]>(`${this.base}/hozzaferesek/${this.intezmeny}`).toPromise()) || [];
      this.allomany = (await this.http.get<any[]>(`/api/nyilvantartas/allomany/${this.intezmeny}`).toPromise()) || [];
      this.log = (await this.http.get<any[]>(`${this.base}/log/${this.intezmeny}`).toPromise()) || [];
      this.utemezo = (await this.http.get<any>(`${this.base}/utemezo/${this.intezmeny}`).toPromise()) || this.utemezo;
      this.jegyAllapot = await this.http.get<any>(`${this.base}/jegyek-allapot/${this.intezmeny}`).toPromise();
      await this.betoltElteresek();
    } catch { /* csendes */ }
    this.betolt = false;
  }

  /* ══════════════════════════════════════════════════════════════════════════
   *  ELTÉRÉSEK — amit a KRÉTÁ-ban is javítani kell.
   *
   *  A szinkron egyszer viszi át a jegyet, utána nem nyúl hozzá: a KRÉTA Save ÚJ
   *  értékelést hoz létre, nem módosít, tehát az újraküldés megduplázná a jegyet a
   *  hivatalos naplóban. Ezért a tanár utólagos javítása és törlése nem jut el oda.
   *  Eddig erről csak egy buborék szólt a módosítás pillanatában; ez a lista az,
   *  amiből dolgozni lehet.
   * ═══════════════════════════════════════════════════════════════════════ */

  elteres: any = null;
  elteresJelolt: Record<string, boolean> = {};
  elteresFut = false;

  async betoltElteresek() {
    try {
      this.elteres = await this.http.get<any>(`${this.base}/jegyek-elteres/${this.intezmeny}`).toPromise();
      this.elteresJelolt = {};
    } catch { this.elteres = null; }
  }

  get elteresJeloltDb(): number {
    return Object.values(this.elteresJelolt).filter(Boolean).length;
  }

  elteresMind(be: boolean) {
    for (const r of this.elteres?.modositott || []) this.elteresJelolt[r.id] = be;
    for (const r of this.elteres?.torolt || []) this.elteresJelolt[r.id] = be;
  }

  /** Egy mondatban: mi változott, miről mire. */
  elteresSzoveg(r: any): string {
    const d: string[] = [];
    if ((r.miben || []).includes('érték')) d.push(`érték: ${r.kuldott_ertek || '–'} → ${r.mostani_ertek || '–'}`);
    if ((r.miben || []).includes('dátum')) d.push(`dátum: ${r.kuldott_datum || '–'} → ${r.mostani_datum || '–'}`);
    if ((r.miben || []).includes('téma')) d.push(`téma: „${r.kuldott_tema || '–'}" → „${r.mostani_tema || '–'}"`);
    return d.join(' · ');
  }

  /*  A pipa CSAK a listáról veszi le a tételt. A KRÉTÁ-hoz nem nyúlunk, és nem is
   *  állítjuk, hogy hozzányúltunk volna — a javítás ott kézzel történik. */
  async elteresRendezve() {
    if (!this.elteresJeloltDb) return;
    const idk = Object.keys(this.elteresJelolt).filter((k) => this.elteresJelolt[k]);
    if (!confirm(`${idk.length} tételt veszünk le a listáról.\n\n`
      + 'Ez csak azt jelenti, hogy a KRÉTÁ-ban elintézted — a rendszer a KRÉTÁ-hoz nem nyúl.\n'
      + 'Ha a jegyen utóbb megint változtatnak, a tétel visszakerül a listára.')) return;
    this.elteresFut = true;
    try {
      const v: any = await this.http.post(`${this.base}/jegyek-elteres-rendezve/${this.intezmeny}`,
        { idk }).toPromise();
      this.uzen(`${v?.rendezve || 0} tétel levéve a listáról.`, 'success');
      await this.betoltElteresek();
    } catch (e: any) {
      this.uzen(e?.error?.error || 'A jelölés nem sikerült.', 'danger');
    } finally { this.elteresFut = false; }
  }

  /*  JAVÍTÁS A KRÉTÁ-BAN. Előbb mindig PRÓBA: a rendszer belép a jegyet beíró tanár
   *  nevében, megkeresi a jegyet, és megmutatja, pontosan mit írna át – de nem küld.
   *  Az éles gomb csak a próba után, és csak a próbán átment tételekre aktív. */
  javitasEredmeny: any[] | null = null;
  javitasEles = false;
  javitasFut = false;

  get javitasraKesz(): string[] {
    return (this.javitasEredmeny || []).filter((t) => t.ok && t.proba && !t.nincsTeendo).map((t) => t.id);
  }

  javitasSor(t: any): string {
    if (t.nincsTeendo) return 'a KRÉTÁ-ban már ez áll – nincs teendő';
    if (!t.ok) return t.uzenet || 'hiba';
    const muv = t.muvelet === 'torol' ? 'törlés' : 'módosítás';
    const v = t.valtozas ? Object.entries(t.valtozas).map(([k, ertek]: any) => `${k}: „${ertek[0]}" → „${ertek[1]}"`).join(' · ') : '';
    return t.proba ? `${muv} – ezt küldené: ${v || `a ${t.kretaId} azonosítójú jegy törlése`}`
      : `${muv} megtörtént${v ? ` (${v})` : ''}`;
  }

  async javitasKretaban(eles: boolean) {
    const idk = eles ? this.javitasraKesz : Object.keys(this.elteresJelolt).filter((k) => this.elteresJelolt[k]);
    if (!idk.length) return;
    if (eles && !confirm(`${idk.length} jegyet javítunk a KRÉTÁ-ban (módosítás vagy törlés), a jegyet beíró tanár nevében.\n\n`
      + 'Ez az iskola hivatalos naplója. Biztosan folytatod?')) return;
    this.javitasFut = true;
    try {
      const v: any = await this.http.post(`${this.base}/jegyek-elteres-javitas/${this.intezmeny}`,
        { idk, eles }).toPromise();
      this.javitasEredmeny = v?.tetelek || [];
      this.javitasEles = !!v?.eles;
      const jo = (this.javitasEredmeny || []).filter((t) => t.ok).length;
      this.uzen(eles ? `${jo}/${idk.length} jegy javítva a KRÉTÁ-ban.` : `Próba kész: ${jo}/${idk.length} tétel javítható.`,
        jo === idk.length ? 'success' : 'warning');
      if (eles) await this.betoltElteresek();
    } catch (e: any) {
      this.uzen(e?.error?.error || 'A javítás nem futott le.', 'danger');
    } finally { this.javitasFut = false; }
  }

  async mentUtemezo() {
    try {
      const valasz: any = await this.http.put(`${this.base}/utemezo/${this.intezmeny}`, {
        enabled: this.utemezo.enabled ? 1 : 0, intervallum_perc: this.utemezo.intervallum_perc, csak_temas: this.utemezo.csak_temas ? 1 : 0,
        jegyek: this.utemezo.jegyek ? 1 : 0,
        // Üresen hagyva az alapértelmezett cím marad érvényben.
        kreta_host: this.utemezo.kreta_host || '',
      }).toPromise();
      if (valasz?.hasznalt_host) this.utemezo.hasznalt_host = valasz.hasznalt_host;
      this.uzen(`Mentve. A belépés ide megy: ${this.utemezo.hasznalt_host}`, 'success');
    } catch (e: any) { this.uzen(e?.error?.error || 'Mentési hiba.', 'danger'); }
  }

  tanarNev(a: any) { return [a?.viselt_vez, a?.viselt_ker].filter(Boolean).join(' ') || a?.adid || ''; }
  /** Névre vagy azonosítóra illesztő szűrés; a sorrend a kiszolgálóé. */
  get szurtAllomany(): any[] {
    const keres = this.allomanySzuro.trim().toLowerCase();
    if (!keres) return this.allomany || [];
    return (this.allomany || []).filter((a) =>
      String(this.tanarNev(a) || '').toLowerCase().includes(keres)
      || String(a.adid || a.id || '').toLowerCase().includes(keres));
  }

  hozzaferesekById(allomany: string) { return this.hozzaferesek.find((h) => h.allomany === allomany); }
  onAllomanyValt() {
    const a = this.allomany.find((x) => (x.adid || x.id) === this.form.allomany);
    if (a) { this.form.tanar_nev = this.tanarNev(a); if (!this.form.kreta_user) this.form.kreta_user = a.adid || ''; }
  }

  szerkeszt(h: any) {
    this.form = { allomany: h.allomany, tanar_nev: h.tanar_nev, kreta_user: h.kreta_user, kreta_pass: '', kreta_totp: '', aktiv: h.aktiv };
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch {}
  }
  ujForm() { this.form = { allomany: '', tanar_nev: '', kreta_user: '', kreta_pass: '', kreta_totp: '', aktiv: 1 }; }

  async ment() {
    if (!this.form.allomany || !this.form.kreta_user) { this.uzen('Válassz tanárt és add meg a KRÉTA felhasználónevet.', 'warning'); return; }
    try {
      await this.http.post(`${this.base}/hozzaferes`, { intezmeny: this.intezmeny, ...this.form }).toPromise();
      this.uzen('Mentve.', 'success'); this.ujForm(); await this.betoltMind();
    } catch (e: any) { this.uzen(e?.error?.error || 'Mentési hiba.', 'danger'); }
  }

  async torol(h: any) {
    const a = await this.alert.create({
      header: 'Törlés', message: `${h.kreta_user} KRÉTA-belépésének törlése?`,
      buttons: ['Mégse', { text: 'Törlés', role: 'destructive', handler: async () => { await this.http.delete(`${this.base}/hozzaferes/${h.id}`).toPromise(); await this.betoltMind(); } }],
    });
    await a.present();
  }

  private qs() { return `?dryRun=${this.dryRun ? 1 : 0}&csakTemas=${this.csakTemas ? 1 : 0}&jegyek=${this.jegyek ? 1 : 0}`; }

  /** A jegyek összegzése – egy tanárnál és „mindenkinek” futásnál is ugyanabban az alakban. */
  get jegyEredmeny(): any { return this.eredmeny?.jegyek || null; }
  /** A jegy-tételek listája; mindenkire futtatva tanáronként összefűzve. */
  get jegyTetelek(): any[] {
    if (!this.eredmeny) return [];
    if (Array.isArray(this.eredmeny.reszletek)) {
      return this.eredmeny.reszletek.flatMap((r: any) =>
        (r.jegyek?.tetelek || []).map((t: any) => ({ ...t, tanar: r.tanar })));
    }
    return this.eredmeny.jegyek?.tetelek || [];
  }
  jegyAllapotSzin(a: string) {
    return a === 'bekuldve' ? 'success' : a === 'ellenorizve' ? 'primary' : a === 'kretaban' ? 'tertiary'
      : a === 'kihagyva' ? 'medium' : 'danger';
  }
  jegyAllapotNev(a: string) {
    return ({ bekuldve: 'beírva', ellenorizve: 'beírható', kretaban: 'már KRÉTÁ-ban', kihagyva: 'kihagyva', hiba: 'hiba' } as any)[a] || a;
  }

  /*  EGY FIÓK ELLENŐRZÉSE.
   *
   *  A listában eddig csak az utolsó SZINKRON eredménye látszott – abból viszont nem
   *  derül ki, hogy a fiók MOST is működik-e: a jelszó lejárhatott, a 2FA
   *  megváltozhatott, a szerepkört elvehették. Így a hiba csak a következő éles
   *  futáskor bukott ki. Ez a gomb fiókonként, azonnal megmondja – a TÁROLT adattal,
   *  a kolléga jelszavát nem kell ismerned.
   */
  ellenorzesFut = '';
  async ellenoriz(h: any) {
    if (this.ellenorzesFut) return;
    this.ellenorzesFut = h.allomany;
    try {
      const r: any = await this.http.post(`${this.base}/ellenoriz/${this.intezmeny}`,
        { allomany: h.allomany }).toPromise();
      h.utolso_ellenorzes = new Date().toISOString().replace('T', ' ').slice(0, 19);
      h.utolso_ellenorzes_ok = r?.ok ? 1 : 0;
      h.utolso_ellenorzes_uzenet = r?.ok ? r.uzenet : (r?.error || 'Ismeretlen hiba.');
      this.uzen(h.utolso_ellenorzes_uzenet, r?.ok ? 'success' : 'danger');
    } catch (e: any) {
      h.utolso_ellenorzes_ok = 0;
      h.utolso_ellenorzes_uzenet = e?.error?.error || 'Az ellenőrzés nem futott le.';
      this.uzen(h.utolso_ellenorzes_uzenet, 'danger');
    }
    this.ellenorzesFut = '';
  }

  /** Sorban egymás után minden beállított fiók – hosszú, ezért külön gomb. */
  async ellenorizMind() {
    for (const h of this.hozzaferesek) {
      if (!h.aktiv) continue;
      await this.ellenoriz(h);
    }
  }

  async naploz(h: any) {
    if (this.szinkronFut) { this.uzen('Már fut egy szinkron – várd meg, amíg befejeződik.', 'warning'); return; }
    this.fut = true; this.eredmeny = null;
    try { this.eredmeny = await this.http.post(`${this.base}/naploz/${h.id}${this.qs()}`, {}).toPromise(); await this.betoltMind(); }
    catch (e: any) { this.uzen(e?.error?.error || 'Naplózási hiba.', e?.status === 409 ? 'warning' : 'danger'); }
    this.fut = false; this.statuszLeker();
  }

  async naplozMind() {
    if (this.szinkronFut) { this.uzen('Már fut egy szinkron – várd meg, amíg befejeződik.', 'warning'); return; }
    const conf = await this.alert.create({
      header: this.dryRun ? 'Teszt (Validate)' : 'ÉLES naplózás',
      message: this.dryRun
        ? 'Minden aktív tanárra lefut az ellenőrzés – NEM ír a KRÉTA-naplóba, csak megmutatja, mi kerülne be.'
        : `MINDEN aktív tanár megtartott órái${this.jegyek ? ' és rögzített jegyei' : ''} BEÍRÓDNAK a KRÉTA e-naplóba, a tanár saját nevén. Biztosan folytatod?`,
      // FONTOS: a handler NE adja vissza a Promise-t, mert akkor az Ionic a teljes szinkron végéig
      // nyitva tartaná a modalt. Csak elindítjuk (fire-and-forget) → a modal azonnal bezárul.
      buttons: ['Mégse', { text: 'Indítás', handler: () => { this.naplozMindFut(); } }],
    });
    await conf.present();
  }
  /*  A „mindenkinek" menet a HÁTTÉRBEN fut: tanáronként egy KRÉTA-belépés, ötven tanárnál
   *  fél óra is. Korábban a kérés végigvárta, és a hálózat lezárta – a képernyő „Naplózási
   *  hiba"-t írt, miközben a szinkron rendben futott. Most az indítás azonnal visszatér, a
   *  haladást a folyamatjelző mutatja, a végén a részletes eredményt külön kérjük le. */
  private hatterFutasVar = false;
  private async naplozMindFut() {
    this.eredmeny = null;
    try {
      await this.http.post(`${this.base}/naploz-mind/${this.intezmeny}${this.qs()}&hatter=1`, {}).toPromise();
      this.hatterFutasVar = true;
      this.statusz = { ...this.statusz, fut: true };
      this.uzen('A szinkron elindult a háttérben – a folyamatjelző mutatja, hol tart. Elnavigálhatsz közben.', 'medium');
    } catch (e: any) {
      this.uzen(e?.error?.error || 'A szinkron nem indult el.', e?.status === 409 ? 'warning' : 'danger');
    }
    this.statuszLeker();
  }

  megszakitasFut = false;

  /** A futó szinkron (manuális vagy automatikus) leállítása a következő óra előtt. */
  async megszakit() {
    const a = await this.alert.create({
      header: 'Szinkron megszakítása',
      message: 'Az épp feldolgozott óra még befejeződik, a többi kimarad. A már beírt órák a KRÉTÁ-ban maradnak.',
      buttons: ['Mégse', { text: 'Megszakítás', role: 'destructive', handler: () => { this.megszakitKuld(); } }],
    });
    await a.present();
  }
  private async megszakitKuld() {
    this.megszakitasFut = true;
    try {
      const r: any = await this.http.post(`${this.base}/naploz-megszakit/${this.intezmeny}`, {}).toPromise();
      if (r?.statusz) this.statusz = r.statusz;
      this.uzen('Megszakítás kérve – a szinkron a következő óra előtt leáll.', 'medium');
    } catch (e: any) {
      this.uzen(e?.error?.error || 'A megszakítás nem sikerült.', e?.status === 409 ? 'warning' : 'danger');
    }
    this.megszakitasFut = false;
    this.statuszLeker();
  }

  async visszavon(l: any) {
    const a = await this.alert.create({
      header: 'Visszavonás', message: 'A naplóbejegyzés visszavonása a KRÉTÁ-ból (DeleteTanora)?',
      buttons: ['Mégse', { text: 'Visszavon', role: 'destructive', handler: async () => { try { await this.http.post(`${this.base}/visszatorol/${l.id}`, {}).toPromise(); this.uzen('Visszavonva.', 'medium'); await this.betoltMind(); } catch (e: any) { this.uzen(e?.error?.error || 'Visszavonási hiba.', 'danger'); } } }],
    });
    await a.present();
  }

  private async uzen(m: string, color: string) {
    // A KRÉTA hibaüzenetei hosszúak (mit kell javítani) – rövid felvillanásból nem
    // olvasható el, ezért hosszabb ideig áll, és bezárható.
    (await this.toast.create({ message: m, duration: m.length > 90 ? 9000 : 2800, color,
                               buttons: [{ text: 'Bezár', role: 'cancel' }] })).present();
  }
}
